import { render, staticRenderFns } from "./RedoButton.vue?vue&type=template&id=32d7eb40&scoped=true&"
import script from "./RedoButton.vue?vue&type=script&lang=js&"
export * from "./RedoButton.vue?vue&type=script&lang=js&"
import style0 from "./RedoButton.vue?vue&type=style&index=0&id=32d7eb40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d7eb40",
  null
  
)

export default component.exports